import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"

const siteUrl = "https://gregwoodwardphoto.com"

const services = [
  ["01", "Commercial", "commercial"],
  ["02", "Lifestyle & Travel", "lifestyle"],
  ["03", "Sport & Documentary", "sports"],
  ["04", "Video & Film", "moving-image"],
]

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "ItemList",
      itemListElement: services.map(([number, title, slug], i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: title,
        url: `${siteUrl}/services/${slug}/`,
      })),
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Services", item: `${siteUrl}/services/` },
      ],
    },
  ],
}

export default function Services() {
  return (
    <Layout
      seo={{
        title: "Commercial Photography & Video Services | Greg Woodward",
        description:
          "Commercial photography, video and content production by Greg Woodward, based in London and working across the UK: campaigns, lifestyle, travel, sport, documentary and interview-led film.",
        pathname: "/services/",
        schema,
      }}
    >
      <main className="service-page services-index">
        <div className="page-intro">
          <div>
            <span className="service-label">Commercial content production</span>
            <h1>Photography, film and content built around real people and real places.</h1>
          </div>
          <p>
            Based in London, working across the UK and internationally. One
            production can generate the photography, video and social
            content a brand actually needs, not a stack of separate
            suppliers and separate briefs.
          </p>
        </div>

        <div className="services-list">
          {services.map(([number, title, slug]) => (
            <Link key={slug} to={`/services/${slug}/`}>
              <span>{number}</span>
              <strong>{title}</strong>
              <span aria-hidden="true">↗</span>
            </Link>
          ))}
        </div>

        <div className="service-questions">
          <span className="service-label">How this actually works</span>
          <section>
            <h2>Can photography and video come from the same production?</h2>
            <p>
              Yes. Hiring a photographer, a separate videographer and a separate
              production company for one campaign is slow and expensive, and
              rarely produces a consistent visual language. Greg works across
              both disciplines, so a single shoot day can produce campaign
              photography, a short film and social cutdowns together.
            </p>
          </section>
          <section>
            <h2>How much content can one shoot produce?</h2>
            <p>
              A well-planned production can supply a website, a campaign, a
              season of social content, PR imagery, internal communications
              and recruitment material, all from work that already happened,
              rather than commissioning something new every time a channel
              needs feeding.
            </p>
          </section>
          <section>
            <h2>Who has Greg worked with?</h2>
            <p>
              Clients include TUI, Nike, HSBC, Team GB, British Gas and
              Alzheimer's Research UK, among others. See the{" "}
              <Link to="/">selected work</Link> for examples across
              commercial, lifestyle, sport and documentary projects.
            </p>
          </section>
        </div>

        <div className="service-cta">
          <span>Not sure which of these fits your project?</span>
          <Link to="/contact/">
            Tell me about your project <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </main>
    </Layout>
  )
}
